import { Component, OnInit } from '@angular/core';
import { IValueChange } from '../../../core/interfaces/form-value-change.interface';
import { BFBeforeProfileSaveAs, BFOnFormLoadComplete, BFOnValueChange } from '../../../core/interfaces/sdk-profile-hooks.interface';
import { ProfileFormTemplateProviders } from '../../../core/templates/profile-form.template.providers';
import { AbstractProfileFormComponent } from '../../abstract/abstract-profile/abstract-profile-form.component';
import { ProfileLayoutType } from '../../enums/profile-layout-type.enum';
import { BatchAgreement } from '../../models/batch-agreement.model';

@Component({
    selector: 'app-batch-agreement',
    templateUrl: '../../../core/templates/profile-form.template.html',
    styleUrls: ['../../../core/templates/profile-form.template.scss'],
    providers: ProfileFormTemplateProviders
})
export class BatchAgreementComponent extends AbstractProfileFormComponent implements BFBeforeProfileSaveAs, BFOnFormLoadComplete, BFOnValueChange, OnInit {

    fgppBeforeSaveAs(): void {
        this.resetAccountFields();
    }

    fgppFormLoadComplete(): void {
        this.updateProcessStatusReportAvailability();
    }

    fgppValueChanges(change: IValueChange): void {
        switch (change.control) {
            case BatchAgreement.END_PROC_STS_REPORT:
                this.updateProcessStatusReportAvailability();
                break;
            case BatchAgreement.RJCTD_CNCLD_ACC_NO:
                this.updateAccountCurrency(BatchAgreement.RJCTD_CNCLD_ACC_NO, BatchAgreement.RJCTD_CNCLD_ACC_CCY);
                break;
            case BatchAgreement.RTRND_ACC_NO:
                this.updateAccountCurrency(BatchAgreement.RTRND_ACC_NO, BatchAgreement.RTRND_ACC_CCY);
                break;
        }
    }

    private resetAccountFields(): void {
        this.formMgr.get(BatchAgreement.RJCTD_CNCLD_ACC_NO).reset();
        this.formMgr.get(BatchAgreement.RJCTD_CNCLD_ACC_CCY).reset();
        this.formMgr.get(BatchAgreement.RTRND_ACC_NO).reset();
        this.formMgr.get(BatchAgreement.RTRND_ACC_CCY).reset();
    }

    private updateProcessStatusReportAvailability(): void {
        const endOfProcessingStatusReport = this.formMgr.get(BatchAgreement.END_PROC_STS_REPORT);
        const processStatusReport = this.formMgr.get(BatchAgreement.PROCESS_STATUS_REPORT);
        if (endOfProcessingStatusReport.getValue() === '1') {
            processStatusReport.markAsRequired();
            if (this.layoutMode !== ProfileLayoutType.VIEW) {
                processStatusReport.enable();
            }
        } else {
            processStatusReport.disable().markAsOptional().reset();
        }
    }

    private updateAccountCurrency(accountControlId: BatchAgreement, currencyControlId: BatchAgreement): void {
        const data = this.getDrilldownData(accountControlId);
        const currency = data ? data['ACCOUNTS.CURRENCY'] : '';
        this.formMgr.get(currencyControlId).setValue(currency);
    }

}
